import React from "react";
import { TextProps } from "./types";
import ContentSection from "./ContentSection";
import StyledMarkdown from "../StyledMarkdown";
import cx from "classnames";

const Text: React.FC<TextProps> = ({
  data,
  heading,
  align,
  onDark,
  preview = false,
}) => {
  return (
    <ContentSection
      className={cx("my-5 w-full", `align-${align || "left"}`)}
      type={data.type}
      preview={preview}
    >
      {heading}
      <StyledMarkdown onDark={onDark}>{data.body}</StyledMarkdown>
    </ContentSection>
  );
};

export default Text;
